export default __webpack_public_path__ + "static/3-fbe657727c3565848d403e18d211a567.png";